import spinner from './SpinnerSingleton';

export default function spinOnAjaxDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: spinOnAjaxDirectiveCtrl,
	};
}

class spinOnAjaxDirectiveCtrl {
	constructor($element) {
		'ngInject';
		$element.on('click', () => {
			spinner.handleClick($element[0]);
		});
	}
}
